import React from "react";
import _ from "lodash";
import { Select, TextInput, Textarea } from "@mantine/core";
import { IconPencil, IconTrash } from "@tabler/icons";
import { useTranslation } from "react-i18next";
import LocalPageList from "../localPageList";
import ActionCellRender from "../actionCellRender";
import { ENUM_FORM_DISPLAY } from "../pageList";

const PostingRuleLinesEditor = ({ form, formMode, readOnly }) => {
  const { t } = useTranslation();
  const lines = _.get(form.values, "lines") ?? [];

  const tableSchema = {
    hideColumnHeaders: false,
    columns: [
      {
        field: "side",
        headerName: "accounting.postingRule.side",
        width: 100,
      },
      {
        field: "accountCode",
        headerName: "accounting.postingRule.accountCode",
        width: 110,
      },
      {
        field: "amountField",
        headerName: "accounting.postingRule.amountField",
        width: 160,
      },
      {
        field: "description",
        headerName: "Description",
      },
      {
        field: "_actions",
        width: 90,
        cellRender: ActionCellRender,
        isAction: true,
        actions: readOnly
          ? []
          : [
              { name: "edit", icon: IconPencil },
              { name: "delete", icon: IconTrash, props: { color: "red" } },
            ],
      },
    ],
  };

  const lineFormSchema = {
    title: "accounting.postingRule.lineTitle",
    display: { mode: ENUM_FORM_DISPLAY.MODAL, size: "md" },
    closeAfterSave: true,
    initialValues: {
      side: "DEBIT",
    },
    layout: {
      containers: [],
      fields: [
        {
          name: "side",
          component: Select,
          parent: null,
          props: {
            label: "accounting.postingRule.side",
            required: true,
            data: [
              { value: "DEBIT", label: t("accounting.normalBalance.debit") },
              { value: "CREDIT", label: t("accounting.normalBalance.credit") },
            ],
          },
        },
        {
          name: "accountCode",
          component: TextInput,
          parent: null,
          props: {
            label: "accounting.postingRule.accountCode",
            required: true,
            placeholder: "1000",
          },
        },
        {
          name: "amountField",
          component: TextInput,
          parent: null,
          props: {
            label: "accounting.postingRule.amountField",
            required: true,
            placeholder: "clientPayable",
            description: "accounting.postingRule.amountFieldHint",
          },
        },
        {
          name: "description",
          component: Textarea,
          parent: null,
          props: {
            label: "Description",
            minRows: 2,
          },
        },
      ],
    },
  };

  return (
    <LocalPageList
      rows={lines}
      readOnly={readOnly || formMode === "show"}
      btnLabel="accounting.postingRule.addLine"
      tableSchema={tableSchema}
      formSchema={lineFormSchema}
      onFormSubmit={(nextLines) => form.setFieldValue("lines", nextLines)}
    />
  );
};

export default PostingRuleLinesEditor;
